// src/analytics/useGTMEvents.js
import { useCallback } from 'react';

/**
 * Hook to fire GTM events (assuming GTM is already initialized).
 * Safe for SSR and CSP-friendly.
 */
export default function useGTMEvents(dataLayerName = 'dataLayer') {
    const getDataLayer = useCallback(() => {
        if (typeof window === 'undefined') {
            return null;
        }
        if (!window[dataLayerName]) {
            window[dataLayerName] = [];
        }

        return window[dataLayerName];
    }, [dataLayerName]);

    const push = useCallback(
        (obj) => {
            if (!obj) {
                return;
            }
            const dl = getDataLayer();
            if (!dl) {
                return;
            }

            try {
                dl.push(obj);
            } catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    console.error('[GTM] push failed:', e, obj);
                }
            }
        },
        [getDataLayer]
    );

    const event = useCallback(
        (name, params = {}) => {
            if (!name) {
                return;
            }
            push({ event: name, ...params });
        },
        [push]
    );

    return { event, push };
}
